import { UserPreferenceContext } from '@contexts/user-preference-context';
import MenuItem from '@navigation/menu-item';
import { useContext } from 'react';

interface TestDataMenuProps {
  showChildrenWithText?: boolean;
  isPreview?: boolean;
}

interface TestDataMenuItemPros {
  lIcon: string;
  displayText: string;
  url: string;
  urlMatcherRegex: RegExp;
  canAccess: boolean;
  displayLink: boolean;
}
const TestDataMenu: React.FC<TestDataMenuProps> = ({
  showChildrenWithText,
  isPreview = false,
}) => {
  const projectPreference = useContext(UserPreferenceContext)?.userPreference
    ?.preference?.projectPreference;

  const canShowUploads = () => {
    return !projectPreference?.selectedVersion?.application?.isRest;
  };

  const testDataMenuItemPros: TestDataMenuItemPros[] = [
    {
      lIcon: '',
      displayText: 'left.nav.test_data_profile',
      url: isPreview ? 'data' : 'td/data',
      urlMatcherRegex: isPreview
        ? new RegExp(/preview\/(\d+)\/data/g)
        : new RegExp(/td\/(\d+)\/data/g),
      canAccess: true,
      displayLink: true,
    },
    ...(!isPreview
      ? [
          {
            lIcon: '',
            displayText: 'left.nav.environments',
            url: 'td/environments',
            urlMatcherRegex: new RegExp(/td\/(\d+)\/environments/g),
            canAccess: true,
            displayLink: true,
          },
          {
            lIcon: '',
            displayText: 'left.nav.uploads',
            url: 'td/uploads',
            urlMatcherRegex: new RegExp(/td\/(\d+)\/uploads/g),
            canAccess: canShowUploads(),
            displayLink: true,
          },
        ]
      : []),
  ].filter(Boolean);
  return (
    <>
      {testDataMenuItemPros.map(
        (item) =>
          item?.canAccess && (
            <MenuItem
              key={item?.displayText}
              isLeftIcon={item?.lIcon}
              itemKey={item?.displayText}
              navUrl={item?.url}
              showWithText={showChildrenWithText}
              urlMatcherRegex={item?.urlMatcherRegex}
              isChild={true}
              displayLink={item?.displayLink}
            />
          ),
      )}
    </>
  );
};

export default TestDataMenu;
